var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedin36X36(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.6185 0.364258H3.37305C1.8763 0.364258 0.666016 1.5459 0.666016 3.00684V34.3812C0.666016 35.8421 1.8763 37.0309 3.37305 37.0309H34.6185C36.1152 37.0309 37.3327 35.8421 37.3327 34.3883V3.00684C37.3327 1.5459 36.1152 0.364258 34.6185 0.364258ZM11.5443 31.6097H6.10156V14.1071H11.5443V31.6097ZM8.82292 11.7223C7.07552 11.7223 5.66471 10.3115 5.66471 8.57129C5.66471 6.83105 7.07552 5.42025 8.82292 5.42025C10.5632 5.42025 11.974 6.83105 11.974 8.57129C11.974 10.3044 10.5632 11.7223 8.82292 11.7223ZM31.9115 31.6097H26.4759V23.1019C26.4759 21.0752 26.4401 18.4613 23.6471 18.4613C20.8184 18.4613 20.3887 20.6742 20.3887 22.9587V31.6097H14.9603V14.1071H20.1738V16.499H20.2454C20.9687 15.124 22.7448 13.6702 25.3874 13.6702C30.8945 13.6702 31.9115 17.2939 31.9115 22.0062V31.6097V31.6097Z",
    fill: "#F9FAFB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin36X36);
export default __webpack_public_path__ + "static/media/Linkedin36x36.759e7b26f5632c56b510c156b3088fec.svg";
export { ForwardRef as ReactComponent };